export default [{
  name: 'consult',
  path: '/consult',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/consult/Consult.vue').default
}]
